import { normalizeCancerTypeName } from './normalize-cancer-type-name';

export function formatCancerTypeNameWithCapitalization(cancerType: string) {
  return normalizeCancerTypeName(cancerType)
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
